export default "__VITE_ASSET__BRguWZma__"